import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import { ResolverTag } from '@swf/core/enums';
import useResolver from '@swf/core/hooks/useResolver';

import {
  TXTCLI_If_you_or_someone_you_know_has_ELL,
  TXTCLI_Responsible_Gaming,
  TXTMOB_In_partnership_with
} from './RegulatoryHeaderPA.messages.json';
import styles from './RegulatoryHeaderPA.scss';
import mountAiryLogo from './assets/ma-logo.png';
import ResponsibleGamingIcon from './assets/uspa-rg-logo.svg';

const RegulatoryHeaderPA = () => {
  const helpResponsibleGaming = useResolver(ResolverTag.HelpResponsibleGaming);

  return (
    <>
      <div className={styles.partnership}>
        <div className={styles.regulatoryText}>
          <Translation {...TXTMOB_In_partnership_with} />
        </div>
        <img width={105} height={26} src={mountAiryLogo} alt="" />
      </div>

      <div className={styles.responsibleGaming}>
        <div className={styles.regulatoryText}>
          <Translation {...TXTCLI_If_you_or_someone_you_know_has_ELL} />
        </div>

        <a
          className={styles.responsibleGamingLinks}
          href={helpResponsibleGaming}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ResponsibleGamingIcon width={24} height={24} />
          <Translation tagName="span" {...TXTCLI_Responsible_Gaming} />
        </a>
      </div>
    </>
  );
};

export default RegulatoryHeaderPA;
